// @owners { team: patients-team }
import { useMemo } from 'react';
import { getAllAddresses } from '~shared/features/addresses/selectors/getAddresses';
import { getCurrentUserDefaultAddress } from '~shared/features/checkout/selectors/getDefaultAddress';
import { getOrderAddressId } from '~shared/features/checkout/selectors/getOrder';
import { getShipmentAddress } from '~shared/features/shipments/selectors/getShipments';
import { getCurrentUserID } from '~shared/features/users/selectors/getUsers';
import type { ShipmentIDParamLong } from '~shared/selectors/selectorParamTypes';
import { useSelectorShared } from '~shared/store';

export const useEssentialsAddress = ({ shipmentID }: ShipmentIDParamLong = { shipmentID: null }) => {
  const userId = useSelectorShared(getCurrentUserID);
  const shipmentAddress = useSelectorShared((state) => getShipmentAddress(state, { shipmentID }));
  const orderAddressID = useSelectorShared(getOrderAddressId);
  const allAddresses = useSelectorShared(getAllAddresses);
  const defaultAddress = useSelectorShared(getCurrentUserDefaultAddress);

  const orderAddress = useMemo(() => {
    return allAddresses.find((address) => address.id === orderAddressID);
  }, [allAddresses, orderAddressID]);

  if (shipmentID) {
    return shipmentAddress;
  }

  if (orderAddress?.user_id === userId) {
    return orderAddress || defaultAddress;
  }

  return defaultAddress;
};
